<div class="faspinner" *ngIf="loading">
  <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
</div>
<div *ngIf="!loading">
  <!-- <app-back-page (backAction)="backToMainPage($event)"></app-back-page> -->
  <div class="field Extra">
    <div class="label" style="margin-bottom: .5rem;">{{'tableinfo.name'|translate}}</div>
    <dx-text-box class="text-center" [(value)]="Extraname">
      <dx-validator>
        <dxi-validation-rule type="required" message="{{'errors.namerequired'|translate}}">
        </dxi-validation-rule>
        <dxi-validation-rule type="async" message="{{'errors.token'|translate}} !!"
          [validationCallback]="validateAsync">
        </dxi-validation-rule>
      </dx-validator>
    </dx-text-box>
  </div>
  <dx-data-grid id="gridContainer" [dataSource]="dataSource" [allowColumnReordering]="true" [showBorders]="false"
    [errorRowEnabled]="false" [rtlEnabled]="currentLang=='ar'?true:false" (onInitNewRow)="onInitNewRow($event)"
    style="margin: 1rem;">
    <dxo-paging [enabled]="true"></dxo-paging>
    <dxo-editing mode="cell" [allowUpdating]="true" [allowDeleting]="false" [allowAdding]="false" [texts]="button">
    </dxo-editing>
    <dxi-column dataField="nameAr" [width]="190" caption="{{'tableinfo.NameAr'|translate}}" [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="nameEn" caption="{{'tableinfo.NameEn'|translate}}" [allowEditing]="false"></dxi-column>

    <dxi-column dataField="dateOfRegistration" dataType="date" [allowEditing]="false"
      caption="{{'tableinfo.dateOfRegistration'|translate}}"></dxi-column>

    <dxi-column dataField="durationType" caption="{{'workSystemSetting.DeductionRules.Timing' |translate}}"
      [allowEditing]="false">
      <dxo-lookup [dataSource]="durationType" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="taxableStatus" caption="{{'tableinfo.status'|translate}}" [allowEditing]="false">
      <dxo-lookup [dataSource]="TaxableStatus" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="fromRule" caption="{{'tableinfo.from'|translate}}" dataType="number" [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="toRule" caption="{{'tableinfo.to'|translate}}" dataType="number" [allowEditing]="false">
    </dxi-column>

    <dxi-column dataField="description" caption="{{'tableinfo.description'|translate}}"
      [allowEditing]="false"></dxi-column>
    <dxi-column dataField="isActive" dataType="boolean" caption="{{'tableinfo.isActive'|translate}}"
      [allowEditing]="false"></dxi-column>
    <dxi-column dataField="isAsgine" dataType="boolean" caption="{{'tableinfo.isAssigned'|translate}}"></dxi-column>

    <dxi-column type="buttons">
      <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
    </dxi-column>
    <dxo-remote-operations [groupPaging]="true">
    </dxo-remote-operations>
  </dx-data-grid>
  <p style="color: red;margin: 0;text-align: center;"
    *ngIf="(ServerError$ |async)?.ExtraTimeRules && (ServerError$ |async) as ServerError">
    {{ServerError['ExtraTimeRules']}}</p>
  <dx-button stylingMode="outlined" text="{{'employeeduration.submit'|translate}}" type="default"
    (onClick)="onFormSubmit($event)" [disabled]="dataSource.length <= 0 || Extraname==''" style="margin: 1rem;
    width: 10rem;
    display: flex;
    float: left;">
  </dx-button>

</div>